import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getAccountDetails } from '../../../../actions/adminActions';
import { getAccountPermissions } from '../../../../actions/roleActions';

import UserTeamAccountList from '../UserTeams/UserTeamAccountList';
import RoleListBox from '../../RoleListBox/RoleListBox';
import UserPermissionsList from './UserPermissionsList';

class UserRoles extends Component {
  static propTypes = {
    userDetails: PropTypes.instanceOf(Object),
    activeRoles: PropTypes.instanceOf(Object),
    activeAccounts: PropTypes.instanceOf(Array),
    accounts: PropTypes.instanceOf(Array),
    updatedRole: PropTypes.func,
    updatedActiveAccounts: PropTypes.func,
    isSuperUser: PropTypes.bool,
  };
  static defaultProps = {
    userDetails: {},
    activeRoles: {},
    isSuperUser: false,
  };

  state = {
    accounts: [],
    activeRoles: {},
    roles: '',
    hasAccounts: true,
    availableRoles: {},
    fetchRoles: true,
    activeAccountId: '',
    permissions: {},
    isTpAccount: false,
    isDisableAdminToogle: false,
    hasNoMriSimmons: false,
    isAdmin: 0,
  };

  UNSAFE_componentWillMount() {
    this.getUserRoles();
  }
  getUserRoles = () => {
    const response = this.props.activeRoles;
    const activeAccounts = this.props.activeAccounts;
    const allAccounts = this.props.accounts;

    if (_.isEmpty(activeAccounts)) {
      this.setState({ hasAccounts: false });
    } else {
      const roles = response ? _.groupBy(response, 'accountId') : {};
      const accounts = [];
      if (
        _.isEmpty(activeAccounts.filter(account => account.accountId === 2823))
      ) {
        this.setState({ hasNoMriSimmons: true });
      }
      allAccounts.map(account => {
        const { accountId, accountType, publicId } = account;
        const activeAccount = _.filter(
          activeAccounts,
          item => item.accountId === accountId
        );
        const selected = activeAccount.length > 0;
        const accountName =
          accountType === 'TPP'
            ? account.accountName + ' (Third Party)'
            : account.accountName;
        if (selected) {
          this._isAdmin(this.props.activeAccounts, activeAccount[0].accountId);

          accounts.push({
            accountId,
            accountName,
            publicId,
          });
        }
        return null;
      });
      this.setState({ accounts, roles, hasAccounts: true, activeRoles: roles });
    }
  };

  _isTpAccount = (accounts, accountId) => {
    const activeAccount =
      accounts && accounts.find(account => account.accountId === accountId);
    const isTpAccount = activeAccount && activeAccount.accountType === 'TPP';
    this.setState({ isTpAccount });
    return isTpAccount;
  };

  _isAdmin = (accounts, accountId) => {
    const activeAccount =
      accounts && accounts.find(account => account.accountId === accountId);
    const isAdmin = activeAccount && activeAccount.accessType ? true : false;
    this.setState({ isAdmin: isAdmin });
    return;
  };

  handleAccountChange = (accountId, publicId) => {
    const { userId } = this.props.userDetails;

    const isTpAccount = this._isTpAccount(this.props.accounts, accountId);
    const isAdmin = this._isAdmin(this.props.activeAccounts, accountId);
    if (accountId === 2823) {
      this.setState({ isDisableAdminToogle: true });
    } else {
      this.setState({ isDisableAdminToogle: false });
    }
    if (isTpAccount) {
      this.setState({ activeAccountId: accountId, fetchRoles: false });
      return false;
    }

    this.setState(
      {
        fetchRoles: true,
        activeAccountId: accountId,
      },
      () => {
        const availableRoles = _.cloneDeep(this.state.availableRoles);
        if (
          !this.state.availableRoles[accountId] &&
          _.isEmpty(this.state.availableRoles[accountId])
        ) {
          getAccountDetails(publicId).then(response => {
            if (response) {
              availableRoles[accountId] = response.roles || [];
              this.setPermissions(accountId, availableRoles);
              if (!userId) {
                this.setState({
                  availableRoles,
                  fetchRoles: false,
                });
              }
            }
          });
        }
      }
    );
  };

  handleAdminAccessChange = isAdminSel => {
    const accounts = this.props.activeAccounts;
    const activeAccount = this.state.activeAccountId;
    accounts.find(
      data => data.accountId === activeAccount
    ).accessType = !isAdminSel ? 1 : 0;
    this.setState({ accounts, isAdmin: !isAdminSel });
    this.props.updatedActiveAccounts(accounts);
  };
  setPermissions = (accountId, availableRoles) => {
    const { userId } = this.props.userDetails;
    const permissions = _.cloneDeep(this.state.permissions);
    if (userId) {
      getAccountPermissions(userId, accountId).then(response => {
        if (response && response.data) {
          permissions[accountId] = response.data || [];
          this.setState({
            permissions,
            availableRoles,
            fetchRoles: false,
          });
        }
      });
    }
  };

  updateSelectedItems = activeRoles => {
    const { activeAccountId } = this.state;
    const newActiveRoles = _.cloneDeep(this.state.activeRoles);
    newActiveRoles[activeAccountId] = activeRoles;
    this.setState({ activeRoles: newActiveRoles }, () => {
      const activeRoleItems = [];
      const activeRole = [];
      Object.keys(this.state.activeRoles).map(item => {
        this.state.activeRoles[item].map(role => {
          activeRole.push(role.id);
          return false;
        });
        return false;
      });

      Object.keys(this.state.availableRoles).map(item => {
        this.state.availableRoles[item].map(role => {
          const hasKey = activeRole.includes(role.id);
          if (hasKey) {
            activeRoleItems.push(role);
          }
          return false;
        });
        return false;
      });

      const groupedRoles = _.cloneDeep(newActiveRoles);
      const groupedActiveRoles = _.groupBy(activeRoleItems, 'accountId');
      if (
        groupedActiveRoles[activeAccountId] &&
        groupedActiveRoles[activeAccountId].length > 0
      ) {
        groupedRoles[activeAccountId] = groupedActiveRoles[activeAccountId];
      } else {
        groupedRoles[activeAccountId] = [];
      }
      _.map(activeRoleItems, item => {
        if (item.accountId !== activeAccountId) {
          const hasRole = _.filter(
            groupedRoles[item.accountId],
            rl => rl.id === item.id
          );
          if (_.isEmpty(hasRole)) {
            groupedRoles[item.accountId] = [
              ...groupedRoles[item.accountId],
              item,
            ];
          }
        }
      });

      let updatedRoles = [];
      Object.keys(groupedRoles).map(ac => {
        updatedRoles = [...updatedRoles, ...groupedRoles[ac]];
        return false;
      });
      this.props.updatedRole(updatedRoles);
    });
  };

  renderRoleBox = () => {
    const {
      availableRoles,
      activeRoles,
      fetchRoles,
      activeAccountId,
      permissions,
    } = this.state;
    let renderRoleBox = '';
    if (_.isEmpty(availableRoles[activeAccountId]) && !fetchRoles) {
      renderRoleBox = (
        <div className="accounts-role-users user-team-box">
          <div className="no-team padding-20">
            No Role assigned to this account!
          </div>
        </div>
      );
    } else if (!_.isEmpty(availableRoles[activeAccountId])) {
      renderRoleBox = (
        <div className="accounts-role-users user-team-box">
          <RoleListBox
            roles={availableRoles[activeAccountId].filter(
              data => data.activeStatus !== 'N'
            )}
            activeRoles={activeRoles[activeAccountId]}
            updateSelectedItems={this.updateSelectedItems}
            clearUsers={false}
            userPermission={permissions[activeAccountId]}
          />
        </div>
      );
    }
    return renderRoleBox;
  };

  renderTPMessage = () => {
    return (
      <div className="accounts-role-users user-team-box">
        <div
          className="no-team padding-20"
          style={{ fontWeight: 600, color: '#ff8300' }}
        >
          A Role cannot be created or associated to a Third Party Account.
        </div>
      </div>
    );
  };

  renderOverallPermissions = () => {
    const { permissions, activeAccountId } = this.state;
    if (!_.isEmpty(permissions[activeAccountId])) {
      return (
        <div className="user-roles--all-permissions-box">
          <div className="user-roles--all-permissions">
            <UserPermissionsList
              headingText={'Overall Access'}
              modules={permissions[activeAccountId]}
            />
          </div>
        </div>
      );
    }
    return null;
  };

  render() {
    const {
      accounts,
      hasAccounts,
      isTpAccount,
      isDisableAdminToogle,
      isAdmin,
      hasNoMriSimmons,
    } = this.state;

    let rendercontent = <div>loading...</div>;
    if (_.isEmpty(accounts) && !hasAccounts) {
      rendercontent = <div className="no-accounts">No Account assigned.</div>;
    } else if (!_.isEmpty(accounts)) {
      rendercontent = (
        <div>
          <UserTeamAccountList
            handleAccountChange={this.handleAccountChange}
            handleAdminAccessChange={this.handleAdminAccessChange}
            accounts={accounts}
            isDisableAdminToogle={
              isDisableAdminToogle || !this.props.isSuperUser || hasNoMriSimmons
            }
            isAdmin={isAdmin}
            isRoles={true}
          />
          {this.renderOverallPermissions()}
          {isTpAccount ? this.renderTPMessage() : this.renderRoleBox()}
        </div>
      );
    }
    return (
      <div className="user-roles user-teams">
        <div className="accounts-role--details">{rendercontent}</div>
      </div>
    );
  }
}

export default UserRoles;
